import React, { useCallback, useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import { useHistory } from "react-router-dom";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import DynamicInput from "components/DynamicInput/DynamicInput";
import Button from "components/CustomButtons/Button.js";
import { Tooltip } from '@material-ui/core';
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Snackbars from "components/Snackbar/Snackbar.js";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";

import './styles.css'
// actions creators
import {
  setUsername,
  setPassword,
  initSession,
  clearError,
} from "redux/ducks/login";
import {
  clearResponse,
} from "redux/ducks/resetPassword";
import { FormLogin } from "./FormLogin";
import { useSearch } from "hooks/useSearch";
import { useToggle } from "hooks/useToggle";
import { InactivityCounter } from "layouts/admin/InactivityCounter";
import { getPersistLocalStorage } from "helpers/localstorageTool";
const useStyles = makeStyles(styles);

export default function LoginPage() {
  const dispatch = useDispatch();
  const [isResetPass, setIsResetPassword] = useToggle();
  const { buildCompLoadings, clearSnackbar } = useSearch()
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  // selectors
  const { isOpen, message, color } = useSelector(({search}) => search)
  const {username, inactive} = useSelector((state) => state.login, shallowEqual);
  const password = useSelector(
    (state) => (state.login.password ? state.login.password : ""),
    shallowEqual
  );
  const { error, errorMessage } = useSelector(
    (state) => state.login,
    shallowEqual
  );
  // const inactive = getPersistLocalStorage('inactive')
  const sendData = useCallback(
    (body) => {
      dispatch(initSession(body));
    },
    [dispatch]
  );

  const handleSubmit = () => {
    if (!username) {
      return;
    }
    if (!password) {
      return;
    }

    const body = {
      password,
      username,
    };
    sendData(body);
  };
  setTimeout(function() {
    setCardAnimation("");
  }, 700);
  const classes = useStyles();

  let history = useHistory();

  const handleChangePage = (page) => {
    history.push(page);
  };
  const isPristineUsername = () => username.length > 4 && false;

  useEffect(() => {
    buildCompLoadings(["loginLoading"])
  }, [])

  return (
    <>
    {inactive && <InactivityCounter />}
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={4}>
            <form>
              <Card login className={classes[cardAnimaton]}>
                <CardHeader
                  className={`${classes.cardHeader} ${classes.textCenter} gn4-login-header`}
                  color="info"
                >
                  <h4 className={classes.cardTitle}>{
                     isResetPass ? "Recuperar contraseña" : "Iniciar sesión"
                  }</h4>
                </CardHeader>
                <CardBody>
                 <FormLogin isResetPass={isResetPass} setIsResetPassword={setIsResetPassword} inactive={inactive}/>
                </CardBody>
              </Card>
            </form>
          </GridItem>
        </GridContainer>
      </div>
      <Snackbars
        place="tr"
        color="danger"
        message={errorMessage}
        open={error}
        closeNotification={() => clearSnackbar()}
        close
      />
      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isOpen}
        closeNotification={clearSnackbar}
        close
      />
    </>
  );
}
